import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'react-mdl/extra/material.css';   //link to index.js to access all the .js
import 'react-mdl/extra/material.js';
import './edu-prd-home_assets/css/font-awesome.min.css';
// // import './edu-prd-home_assets/css/main.css';
// // import './edu-prd-home_assets/js/jquery.min.js';
// import './edu-prd-home_assets/js/skel.min.js';
// import './edu-prd-home_assets/js/templated-theory_main.js';
// // import './edu-prd-home_assets/js/util.js';


import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
  , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js